import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const InspectionTranslationKeys = {
  add: translationKey('answer_add'),
  addOption: translationKey('answer_add_option'),
  label: translationKey('answer_label'),
  multiselect: translationKey('answer_multiselect'),
  noAnswers: translationKey('answer_no_answers'),
  normMax: translationKey('answer_norm_max'),
  normMin: translationKey('answer_norm_min'),
  option: translationKey('answer_option'),
  rangeMax: translationKey('answer_range_max'),
  rangeMin: translationKey('answer_range_min'),
  required: translationKey('answer_required'),
  sliderConfigHelper: translationKey('answer_slider_config_helper'),
  sliderConfigLabel: translationKey('answer_slider_config_label'),
  step: translationKey('answer_step'),
  tabAnswers: translationKey('answer_tab_answers'),
  tabBasic: translationKey('answer_tab_basic'),
  typeCompliance: translationKey('answer_type_compliance'),
  typeNumeric: translationKey('answer_type_numeric'),
  typeOptionSelection: translationKey('answer_type_option_selection'),
  typeText: translationKey('answer_type_text'),
  unit: translationKey('answer_unit'),
  itemPreviewFieldLabelAnswers: translationKey('checklist_item_preview_field_label_answers'),
  itemPreviewFieldLabelDescription: translationKey('checklist_item_preview_field_label_description'),
  sectionPreviewFieldLabelTemplateAttachments: translationKey('checklist_section_preview_field_label_template_attachments'),
  notApplicable: translationKey('compliance_option_not_applicable'),
  notPassed: translationKey('compliance_option_not_passed'),
  passed: translationKey('compliance_option_passed'),
  unset: translationKey('compliance_option_unset'),
  controlledElement: translationKey('controlled_element'),
  controlledElements: translationKey('controlled_elements'),
  failedInspectionFactorChart: translationKey('failed_inspection_factor_chart'),
  editInspection: translationKey('hover_card_edit_inspection'),
  editUser: translationKey('hover_card_edit_user'),
  exportInspectionPdf: translationKey('hover_card_export_inspection_pdf'),
  openDetailedViewInspection: translationKey('hover_card_open_detailed_view_inspection'),
  openDetailedViewUser: translationKey('hover_card_open_detailed_view_user'),
  actionExport: translationKey('inspection_action_export'),
  addAttachments: translationKey('inspection_add_attachments'),
  addComment: translationKey('inspection_add_comment'),
  addIssue: translationKey('inspection_add_issue'),
  answersNotFilledError: translationKey('inspection_answers_not_filled_error'),
  attachments: translationKey('inspection_attachments'),
  columnLabelAuthor: translationKey('inspection_column_label_author'),
  columnLabelControlledParty: translationKey('inspection_column_label_controlled_party'),
  columnLabelExecutionDate: translationKey('inspection_column_label_execution_date'),
  columnLabelInspectionNumber: translationKey('inspection_column_label_inspection_number'),
  columnLabelLevel: translationKey('inspection_column_label_level'),
  columnLabelOrderNumber: translationKey('inspection_column_label_order_number'),
  columnLabelProcessCode: translationKey('inspection_column_label_process_code'),
  columnLabelResult: translationKey('inspection_column_label_result'),
  columnLabelSite: translationKey('inspection_column_label_site'),
  columnLabelState: translationKey('inspection_column_label_state'),
  columnLabelStatus: translationKey('inspection_column_label_status'),
  columnLabelSummary: translationKey('inspection_column_label_summary'),
  columnLabelWorkTypes: translationKey('inspection_column_label_work_types'),
  comment: translationKey('inspection_comment'),
  commentAddPlaceholder: translationKey('inspection_comment_add_placeholder'),
  commentTextFormatting: translationKey('inspection_comment_text_formatting'),
  commentToolbarHide: translationKey('inspection_comment_toolbar_hide'),
  commentToolbarShow: translationKey('inspection_comment_toolbar_show'),
  contractNumber: translationKey('inspection_contract_number'),
  controlledParty: translationKey('inspection_controlled_party'),
  countPlural: translationKey('inspection_count_plural'),
  dropFilesToInspectionAttachments: translationKey('inspection_drop_files_to_inspection_attachments'),
  editOnArchivedWarning: translationKey('inspection_edit_on_archived_warning'),
  editOnCompletedWarning: translationKey('inspection_edit_on_completed_warning'),
  emptyInfo: translationKey('inspection_empty_info'),
  evolutionChart: translationKey('inspection_evolution_chart'),
  executionDate: translationKey('inspection_execution_date'),
  formIssueProcessEditWarning: translationKey('inspection_form_issue_process_edit_warning'),
  formIssueSiteEditWarning: translationKey('inspection_form_issue_site_edit_warning'),
  formLabelScore: translationKey('inspection_form_label_score'),
  issueSummary: translationKey('inspection_issue_summary'),
  newTitle: translationKey('inspection_new_title'),
  number: translationKey('inspection_number'),
  previewCreatedBy: translationKey('inspection_preview_created_by'),
  previewInspectionRemoved: translationKey('inspection_preview_inspection_removed'),
  previewToolbarTitle: translationKey('inspection_preview_toolbar_title'),
  protocolItemAnsweredSummary: translationKey('inspection_protocol_item_answered_summary'),
  relatedIssuesCount: translationKey('inspection_related_issues_count'),
  sectionAnsweredSummary: translationKey('inspection_section_answered_summary'),
  startOnArchivedTemplateWarning: translationKey('inspection_start_on_archived_template_warning'),
  stateActiveTooltip: translationKey('inspection_state_active_tooltip'),
  stateActiveValue: translationKey('inspection_state_active_value'),
  stateArchivedTooltip: translationKey('inspection_state_archived_tooltip'),
  stateArchivedValue: translationKey('inspection_state_archived_value'),
  status: translationKey('inspection_status'),
  statusCompleted: translationKey('inspection_status_completed'),
  statusInProgress: translationKey('inspection_status_in_progress'),
  statusTooltip: translationKey('inspection_status_tooltip'),
  summaryChart: translationKey('inspection_summary_chart'),
  tableAuthor: translationKey('inspection_table_author'),
  tableExecutionDate: translationKey('inspection_table_execution_date'),
  tableStatus: translationKey('inspection_table_status'),
  tableSummary: translationKey('inspection_table_summary'),
  tableWorkType: translationKey('inspection_table_work_type'),
  textAnswerPlaceholder: translationKey('inspection_text_answer_placeholder'),
  noAnswerTypesConfigured: translationKey('no_answer_types_configured'),
  notCompatibleHelperText: translationKey('not_compatible_helper_text'),
  numericAnswerOutOfNormWarning: translationKey('numeric_answer_out_of_norm_warning'),
  progressRowTooltipDataAvailable: translationKey('progress_row_tooltip_data_available'),
  progressRowTooltipNoDataBoth: translationKey('progress_row_tooltip_no_data_both'),
  progressRowTooltipNoDataCompleted: translationKey('progress_row_tooltip_no_data_completed'),
  progressRowTooltipNoDataPlanned: translationKey('progress_row_tooltip_no_data_planned'),
  itemComment: translationKey('protocol_item_comment'),
  itemCreateIssueSiteEmptyWarning: translationKey('protocol_item_create_issue_site_empty_warning'),
  itemCreateIssueWarning: translationKey('protocol_item_create_issue_warning'),
  itemCreateIssueWarningTitle: translationKey('protocol_item_create_issue_warning_title'),
  itemFormComatibilityResultNeutral: translationKey('protocol_item_form_comatibility_result_neutral'),
  itemFormCompatibilityMessage: translationKey('protocol_item_form_compatibility_message'),
  itemFormSkippedLabel: translationKey('protocol_item_form_skipped_label'),
  itemIssuesSectionTitle: translationKey('protocol_item_issues_section_title'),
  itemResultNotApplicable: translationKey('protocol_item_result_not_applicable'),
  itemResultNotPassed: translationKey('protocol_item_result_not_passed'),
  itemResultPassed: translationKey('protocol_item_result_passed'),
  itemResultUnset: translationKey('protocol_item_result_unset'),
  saveInspectionAutomatically: translationKey('save_inspection_automatically'),
  snackStartInspectionOnPublishedTemplateError: translationKey('snack_start_inspection_on_published_template_error'),
  startInspectionDisabledNotImplemented: translationKey('start_inspection_disabled_not_implemented'),
  summaryInspectionReport: translationKey('summary_inspection_report'),
} as const satisfies Record<string, TranslationKey>;
